import { SquareDrawer } from "./SquareDrawer.js";
export async function loadSquareShape(engine, refresh = true) {
    await engine.addShape(["edge", "square"], new SquareDrawer(), refresh);
}
